module.exports = __webpack_public_path__ + "img/campfire.e7357ac4.svg";